import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ExternalSipAddressComponent } from "./external-sip-address.component";
import { ExternalSipAddressSetupComponent } from "./externalSipAddressSetup/external-sip-address-setup.component";
import { ExternalSipAddressTableComponent } from "./externalSipAddressTable/external-sip-address-table.component";

const routes: Routes = [
  {
    path: "",
    component: ExternalSipAddressComponent,
    children: [
      {
        path: "",
        component: ExternalSipAddressTableComponent,
        pathMatch: "full",
        data: { title: "External Sip Address" }
      },
      {
        path: "setup",
        component: ExternalSipAddressSetupComponent,
        data: { title: "External Sip Address Setup" }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)]
})
export class ExternalSipAddressRoutingModule {}
